import { Icons } from '@commenda/kakashi';
import { ChatRoomMessageType } from '@commenda/prisma';
import { IChatRoomMessage } from '@commenda/types/src/chat-room/types';
import { cn } from '@commenda/utils';
import ChatAvatar from '../ChatAvatar';
import { RemoveReplyAction } from '../ChatMessages/ChatMessageAction';

export const ReplyMessagePreview = ({
  replyMessage,
  removeReplyMessage,
}: {
  replyMessage: IChatRoomMessage;
  removeReplyMessage?: () => void;
}) => {
  const isReport =
    replyMessage.type === ChatRoomMessageType.ISSUE_REPORTED;
  const isAttachment =
    !replyMessage.message && !!replyMessage.files?.[0]?.fileName;

  const displayText = replyMessage.message
    ? replyMessage.message
    : replyMessage.files?.[0]?.fileName ?? '';

  return (
    <div
      className={cn(
        'flex items-center gap-md px-lg pt-lg pb-2xl -mb-lg rounded-t-2xl',
        isReport
          ? 'bg-bg-error border-border-error-hover hover:bg-bg-error-hover'
          : 'bg-bg-secondary border-border-primary-hover hover:bg-bg-secondary-hover'
      )}
    >
      <ChatAvatar
        size="sm"
        name={replyMessage.user?.name}
        image={replyMessage.user?.avatar}
        colorSeed={replyMessage.user?.id}
      />
      <span
        className={cn(
          'font-mulish text-xs font-medium leading-[15px] flex-1 min-w-0 truncate',
          isReport
            ? 'text-text-error'
            : isAttachment
              ? 'text-text-brand'
              : 'text-text-primary'
        )}
      >
        {displayText}
      </span>
      {removeReplyMessage && (
        <RemoveReplyAction onClick={removeReplyMessage} />
      )}
    </div>
  );
};
